"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNavigation = void 0;
const react_1 = __importDefault(require("react"));
const atome_1 = require("../../atome");
const react_native_1 = require("react-native");
const RootNavigation_1 = require("../../../helper/RootNavigation");
const UserNavigation_style_1 = require("./UserNavigation.style");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const UtilityFunctions_1 = require("../../../helper/UtilityFunctions");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const package_json_1 = require("../../../../package.json");
const native_base_1 = require("native-base");
const Breakpoints_1 = require("../../../helper/Breakpoints");
function UserNavigation({ navigation }) {
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    let actualRoute;
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const isPatientDeclined = userInformation?.isPatientDeclined !== undefined &&
        userInformation?.isPatientDeclined === true;
    if (RootNavigation_1.navigationRef.isReady()) {
        actualRoute = RootNavigation_1.navigationRef.getCurrentRoute();
    }
    const navigateToScreen = (screenName, navigationQuery) => {
        let query;
        if (navigationQuery) {
            query = navigationQuery;
        }
        if (screenName === 'Logout') {
            (0, UtilityFunctions_1.signOff)({ auth: auth, nav: () => navigation.navigate('Login') });
        }
        else {
            navigation.navigate(screenName, query);
        }
    };
    return (react_1.default.createElement(native_base_1.Menu, { zIndex: 999, bgColor: 'white', _backdrop: {
            bg: 'dark.50',
            height: '100vh',
            pointerEvents: 'none',
            zIndex: '10000',
            position: 'absolute',
        }, closeOnSelect: true, w: "320", h: "100vh", top: "-50", left: ['-30', '-50'], onOpen: () => (document.body.style.overflow = 'hidden'), onClose: () => (document.body.style.overflow = 'auto'), shouldOverlapWithTrigger: true, trigger: triggerProps => {
            triggerProps.closeOnOverlayClick = false;
            console.log('triggerProps', triggerProps);
            return (react_1.default.createElement(native_base_1.Pressable, { ...triggerProps, mr: 10 },
                react_1.default.createElement(atome_1.Icon, { icon: "menu", size: Breakpoints_1.isMobile ? 20 : 30 })));
        } },
        react_1.default.createElement(native_base_1.Menu.Item, { bgColor: 'none', mt: 5 },
            react_1.default.createElement(atome_1.Icon, { icon: "nowomed", size: 170 }),
            react_1.default.createElement(native_base_1.CloseIcon, { size: "5", ml: "20", color: "emerald.500" })),
        react_1.default.createElement(native_base_1.Menu.Item, { mt: 12, onPress: () => {
                navigateToScreen('Dashboard');
            } },
            react_1.default.createElement(atome_1.Icon, { icon: "dashboard", size: 25, color: actualRoute?.name === 'Dashboard' ? '#3db384' : 'grey' }),
            react_1.default.createElement(react_native_1.Text, { style: actualRoute?.name === 'Dashboard' ? UserNavigation_style_1.styles.labelGreen : UserNavigation_style_1.styles.label }, "Dashboard")),
        react_1.default.createElement(native_base_1.Menu.Item, { onPress: () => {
                navigateToScreen('Documents', { page: 'my-documents' });
            } },
            react_1.default.createElement(atome_1.Icon, { icon: "document", color: actualRoute?.name === 'Documents' ? '#3db384' : 'grey', size: 35 }),
            react_1.default.createElement(react_native_1.Text, { style: [
                    actualRoute?.name === 'Documents'
                        ? UserNavigation_style_1.styles.labelGreen
                        : UserNavigation_style_1.styles.label,
                    GlobalStyles_1.globalStyles.marginLeftMinus7,
                ] }, "Meine Dokumente")),
        !isPatientDeclined && userInformation?.progress?.isDataConfirm && (react_1.default.createElement(native_base_1.Menu.Item, { onPress: () => {
                navigateToScreen('PatientenTracking');
            } },
            react_1.default.createElement(atome_1.Icon, { icon: "healthTracking", color: actualRoute?.name === 'PatientenTracking' ? '#3db384' : 'grey', size: 25 }),
            react_1.default.createElement(react_native_1.Text, { style: actualRoute?.name === 'PatientenTracking'
                    ? UserNavigation_style_1.styles.labelGreen
                    : UserNavigation_style_1.styles.label }, "Therapie Monitoring"))),
        !isPatientDeclined &&
            auth.isAuthenticated &&
            userInformation?.appointment?.length > 0 && (react_1.default.createElement(native_base_1.Menu.Item, { onPress: () => {
                navigateToScreen('PharmacyPage');
            } },
            react_1.default.createElement(atome_1.Icon, { icon: "pharmacysmall", color: actualRoute?.name === 'PharmacyPage' ? '#3db384' : 'grey', size: 25 }),
            react_1.default.createElement(react_native_1.Text, { style: actualRoute?.name === 'PharmacyPage'
                    ? UserNavigation_style_1.styles.labelGreen
                    : UserNavigation_style_1.styles.label }, "Meine Apotheke"))),
        react_1.default.createElement(native_base_1.Menu.Item, { onPress: () => {
                navigateToScreen('MyAccount');
            } },
            react_1.default.createElement(atome_1.Icon, { icon: "user", color: actualRoute?.name === 'MyAccount' ? '#3db384' : 'grey', size: 25 }),
            react_1.default.createElement(react_native_1.Text, { style: actualRoute?.name === 'MyAccount' ? UserNavigation_style_1.styles.labelGreen : UserNavigation_style_1.styles.label }, "Mein Profil")),
        react_1.default.createElement(native_base_1.Divider, { w: "90%", alignSelf: 'center', style: UserNavigation_style_1.styles.divider }),
        react_1.default.createElement(native_base_1.Menu.Item, { onPress: () => {
                navigateToScreen('Contact');
            } },
            react_1.default.createElement(atome_1.Icon, { icon: "kontakt", color: actualRoute?.name === 'Contact' ? '#3db384' : 'grey', size: 25 }),
            react_1.default.createElement(react_native_1.Text, { style: actualRoute?.name === 'Contact' ? UserNavigation_style_1.styles.labelGreen : UserNavigation_style_1.styles.label }, "Hilfe / Kontakt")),
        react_1.default.createElement(native_base_1.Divider, { w: "90%", alignSelf: 'center', style: UserNavigation_style_1.styles.divider }),
        react_1.default.createElement(native_base_1.Menu.Item, { onPress: () => {
                navigateToScreen('Logout');
            } },
            react_1.default.createElement(atome_1.Icon, { icon: "logout", color: 'grey', size: 25 }),
            react_1.default.createElement(react_native_1.Text, { style: UserNavigation_style_1.styles.label }, "Abmelden")),
        react_1.default.createElement(native_base_1.Divider, { w: "90%", alignSelf: 'center', style: UserNavigation_style_1.styles.divider }),
        react_1.default.createElement(native_base_1.Menu.Item, null,
            react_1.default.createElement(atome_1.Link, { href: "https://www.nowomed.com/de/impressum/", style: [UserNavigation_style_1.styles.linkWithoutIcon] }, "Impressum")),
        react_1.default.createElement(native_base_1.Menu.Item, null,
            react_1.default.createElement(atome_1.Link, { href: "https://www.nowomed.com/de/datenschutz/", style: [UserNavigation_style_1.styles.linkWithoutIcon] }, "Datenschutz")),
        react_1.default.createElement(native_base_1.Menu.Item, { mb: 10 },
            react_1.default.createElement(atome_1.Link, { href: "https://www.nowomed.com/de/agb/", style: [UserNavigation_style_1.styles.linkWithoutIcon] }, "AGB")),
        react_1.default.createElement(native_base_1.View, { bottom: 0, ml: 6, position: 'absolute', display: 'flex', flexDirection: 'row', alignItems: 'center', width: '5/6', justifyContent: 'space-between' },
            react_1.default.createElement(react_native_1.Text, { style: UserNavigation_style_1.styles.versionText }, `Version ${package_json_1.version}`))));
}
exports.UserNavigation = UserNavigation;
